/**
 * @file_purpose  page for showing login form of employee panel
 * @author Sucheta Singha
 * @Date_Created 
 * @Date_Modified 24-02-2023
 */
import React, { useState, useEffect } from 'react'
import { withRouter, useHistory, useLocation, } from 'react-router-dom'
import {
  CButton,
  CCol,
  CForm,
  CInput,
  CInputGroup,
  CRow,
  CLabel
} from '@coreui/react'
import { ToastContainer, toast } from 'react-toastify';
import Constants from 'src/Utility/Constants';
import Service from 'src/apis/Service';
import moment from 'moment';
import Helpers from 'src/Utility/Helpers';
import HiddenEye from "src/assets/icons/hidden_eye.png";
import Eye from "src/assets/icons/eye.png";

const Login = (props) => {
  const history = useHistory();
  const location = useLocation();
  //Define states
  const [state, setState] = useState({
    username: "",
    password: "",
  })

  const [rMe, setRMe] = useState(false);
  const [menuName, setMenuName] = useState('login');
  const [userNameErrors, setUserNameErrors] = useState();

  const [passwordErrors, setPasswordErrors] = useState();
  const [passwordShown, setPasswordShown] = useState(false);

  const crypto = require('crypto');
  let appConfig_IV = '2ebd54f6ee77f34dc78e7e271e3e4c37';
  let appConfig_PASSWORD_SECRET_KEY = 'c00eae67d5e05dab249533fbaaa454d4603c53b3553ec86b49bb52f8bf499b5f';
  const algorithm = "aes-256-cbc";

  let encrypt = (data) => {
    const IV = Buffer.from(appConfig_IV, 'hex') //crypto.randomBytes(16);
    const Securitykey = Buffer.from(appConfig_PASSWORD_SECRET_KEY, 'hex');

    const cipher = crypto.createCipheriv(algorithm, Securitykey, IV);

    let encryptedData = cipher.update(data, "utf-8", "hex");
    encryptedData += cipher.final("hex");

    return encryptedData;
  }
  let decrypt = (hashed_data) => {
    const IV = Buffer.from(appConfig_IV, 'hex') //crypto.randomBytes(16);
    const Securitykey = Buffer.from(appConfig_PASSWORD_SECRET_KEY, 'hex');


    const decipher = crypto.createDecipheriv(algorithm, Securitykey, IV);
    let decryptedData = decipher.update(hashed_data, "hex", "utf-8");
    decryptedData += decipher.final("utf-8");

    return decryptedData;
  }





  const togglePasswordVisibility = () => {
    setPasswordShown(passwordShown ? false : true);
  };
  const handleChange = (e) => {
    const { id, value } = e.target
    setState(prevState => ({
      ...prevState,
      [id]: value
    }))
  }

  const handleMenuSet = (e, menuName) => {
    setMenuName(menuName)
    props.onChangeMenu(menuName);
  }


  useEffect(() => {
    if (location.state) {
      toast.success(location.state.forgotPasswordMessage, {
        position: toast.POSITION.BOTTOM_RIGHT
      });
    }
    const rmeStore = localStorage.getItem("rememberMe");
    if (rmeStore) {
      setRMe(rmeStore);
      const userStore = localStorage.getItem("username");
      const passStore = decrypt(localStorage.getItem("password"));
      if (userStore || passStore) {
        //console.log(userStore);
        setState({ username: userStore || "", password: passStore || "" })
      }

    }
  }, []);


  /* Validation Checking */
  const ValidateForm = (e) => {
    e.preventDefault();
    if (handleValidation()) {

      // if (state.username === "arijit@redappletech.com" ||
      //   state.username === "arup@redappletech.com" ||
      //   state.username === "kaushik@redappletech.com" ||
      //   state.username === "sucheta@redappletech.com") {
      //   LoginSubmitClick();
      // } else {
      //   toast.error("You are not authorized to login", {
      //     position: toast.POSITION.BOTTOM_RIGHT
      //   });
      // }

      LoginSubmitClick();
    }
    else {
      toast.error("Please fill all the fields !", {
        position: toast.POSITION.BOTTOM_RIGHT
      });
    }
  }

  /* Validate all fields */
  const handleValidation = (e) => {
    let usernameErrors, passwordErrors;
    let formIsValid = true;

    //Name
    if (!state.username) {
      formIsValid = false;
      usernameErrors = "Username cannot be empty";
      setUserNameErrors(usernameErrors);
    } else {
      setUserNameErrors('');
    }

    //Email

    if (!state.password) {
      formIsValid = false;
      passwordErrors = "Password can not be empty";
      setPasswordErrors(passwordErrors);
    } else {
      setPasswordErrors('');
    }

    return formIsValid;
  }



  /**
    * @author Sucheta Singha
    * @Date_Created 
    * @Date_Modified 24/02/2023
    * @function sync
    * @functionName LoginSubmitClick
    * @functionPurpose this function submit login form data.
    *
    * @functionParam {payload object:username,password}
    * 
    * @functionSuccess Success status and message.
    *
    * @functionError {Boolean} error error is there.
    * @functionError {String} message  Description message.
    */
  const LoginSubmitClick = (e) => {
    let params = JSON.stringify({
      username: state.username,
      password: state.password,
      panel_status: 1
    })
    Service.generateOTP(params).then(res => {
      if (res.status === Constants.API_RESPONSE_STATUS_SUCCESS) {

        const data = res.data;
        let is_otp_required = data.is_otp_required;
        if (is_otp_required) {
          localStorage.setItem("user_email", state.username);
          toast.success(res.message, {
            position: toast.POSITION.BOTTOM_RIGHT
          });
          // history.push("/verify-otp");
          var now = moment();
          var future = now.add(5, 'minutes');
          localStorage.setItem('expiresTimestamp', future.format("YYYY-MM-DD HH:mm:ss"));
          setMenuName('verify-otp')
          props.onChangeMenu('verify-otp');
        } else {

          if (res.data["is_password_change_required"] == 1) {
            history.push({
              pathname: '/change-password',
              state: { token: res.data["token"] }
            })
          } else {
            if (rMe) {
              localStorage.setItem("username", state.username);
              localStorage.setItem("password", encrypt(state.password));
              localStorage.setItem("rememberMe", true);
            } else {
              localStorage.removeItem("username");
              localStorage.removeItem("password");
              localStorage.removeItem("rememberMe");
            }
            localStorage.removeItem("SelectedMenu");
            // localStorage.removeItem("user_email");

            localStorage.setItem("hrms_formal_id", Helpers.userEncrypt(res.data["user_id"]));
            localStorage.setItem("hrms_rid", Helpers.roleEncrypt(res.data["role_id"]));
            localStorage.setItem("hrms_employee_auth", res.data["token"]);
            localStorage.setItem("hrms_emp_profile_image", res.data["profile_image"]);
            localStorage.setItem("hrms_date_format", res.data["date_settings"]);
            localStorage.setItem("hrms_is_interviewer", res.data["is_interviewer"]);
            localStorage.setItem("hrms_is_recruiter", res.data["is_recruiter"]);
            localStorage.setItem("hrms_is_meeting_host", res.data["is_meeting_host"]);
            localStorage.setItem("hrms_is_drive_user", res.data["is_drive_user"]);
            localStorage.setItem("hrms_username", res.data["name"]);
            localStorage.setItem("hrms_designation", res.data["designation"]);
            localStorage.setItem("hrms_is_tracker_view_user", res.data["is_tracker_view_user"]);
            localStorage.setItem("hrms_is_clock_user", res.data["is_clock_user"]);
            localStorage.setItem("hrms_menu_access", JSON.stringify(res.data["menu_access"]));
            localStorage.setItem("hrms_is_team_lead", res.data["is_team_lead"]);
            localStorage.setItem("hrms_emp_logo", res.data["company_logo"]);
            localStorage.setItem("hrms_emp_items_per_page", 10)
            localStorage.setItem("hrms_emp_is_ticket_manager", res.data["is_ticket_manager"])
            localStorage.setItem("hrms_emp_is_project_manager", res.data["is_project_manager"])
            localStorage.setItem("hrms_company_id", res.data["company_id"]);
            localStorage.setItem("user_email", state.username);
            //history.push("/profile-details");
            history.push("/employee-calender");
            toast.success(res.message, {
              position: toast.POSITION.BOTTOM_RIGHT
            });
            window.location.reload();

          }

        }




      }
      else {
        toast.error(res.message, {
          position: toast.POSITION.BOTTOM_RIGHT
        });
      }
    }).catch(error => {
      console.log(error);
    })
  }


  return (
    <div className="login_sec">
      <ToastContainer />

      <div>
        <CForm className="commentForm" onSubmit={ValidateForm}>
          <h6>Login</h6>

          <div class="login_inner">
            <CLabel htmlFor="text-input">Email address</CLabel>
            <CInput type="email" placeholder="Username" id="username" autoComplete="username" value={state.username}
              onChange={handleChange} />
            <span style={{ color: "red" }}>{userNameErrors}</span>
          </div>

          <div class="login_inner mb-1">
            <CLabel htmlFor="text-input">Password</CLabel>
            <CInputGroup className="mb-2">
              <CInput placeholder="Password" id="password" autoComplete="current-password" value={state.password}
                onChange={handleChange}
                type={passwordShown ? "text" : "password"}

              />
              <img className="hidden_eye" alt='eye-icon' onClick={togglePasswordVisibility} src={passwordShown ? Eye : HiddenEye} style={{ cursor: 'pointer' }}></img>
            </CInputGroup>
            <span style={{ color: "red" }}>{passwordErrors}</span>

            <div className="form-check" style={{ paddingLeft: "21px" }} >
              <input className="form-check-input" type="checkbox" value="" id="rem_me" checked={rMe} onChange={() => setRMe(!rMe)} />
              <CLabel htmlFor="rem_me" style={{ fontWeight: 500 }}> Rememeber Me</CLabel>
            </div>
          </div>

          <CRow>
            {/* <CCol xs="6" ></CCol> */}
            <CCol xs="12" md="12" className="text-right">
              <CButton color="link" className="forgot_pass" onClick={e => handleMenuSet(e, "forgot-password")}>Forgot password?</CButton>
            </CCol>
          </CRow>
          {/* <CRow>  
            <CCol xs="12" md="12" className="text-right">
                <div className="form-check"  style={{ paddingLeft: "10px", paddingTop: "15px" }} >
                  <input className="form-check-input" type="checkbox" value="" id="rem_me" checked={rMe}  onChange={() => setRMe(!rMe)}/>
                  <CLabel htmlFor="rem_me"> Rememeber Me</CLabel>
                </div>
            </CCol>
            </CRow> */}
          <button type="submit" className="login_btn">Login</button>
        </CForm>
      </div>
    </div>
  )
}

export default withRouter(Login)
